import { Box, Stack } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useOrdersSearchParams } from '../email-pulse.hooks';
import EmailPulseHeader from '../email-pulse-header/email-pulse-header.component';
import OrdersSummaryCards from './orders-summary-cards.component';
import ApiDetailsDrawer from '../email-pulse-api-definitions/api-details-drawer.component';
import { transformEmailPulseDataGridResponse } from '../email-pulse.utils';
import {
  useGetEmailPulseOrdersSummaryQuery,
  useGetEmailPulseOrdersEmailsOpenedBreakdownQuery,
  useGetEmailPulseOrdersEmailsBouncedBreakdownQuery,
  useGetEmailPulseOrdersDataQuery,
  useExportEmailPulseOrdersMutation,
} from 'api/reports-service/email-pulse-hooks';
import OrdersDataGrid from './orders-data-grid/orders-data-grid.component';

const filteredSearchParams = [
  'campaignIds',
  'offerIds',
  'messageIds',
  'status',
];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useOrdersSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Orders />
    </SearchParamsProvider>
  );
};

const Orders = () => {
  const { open, close, isOpen } = useDrawer();

  const ordersSummary = useSearchQuery(useGetEmailPulseOrdersSummaryQuery, {
    filteredSearchParams,
  });

  const emailsOpenedBreakdown = useSearchQuery(
    useGetEmailPulseOrdersEmailsOpenedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsBouncedBreakdown = useSearchQuery(
    useGetEmailPulseOrdersEmailsBouncedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const ordersDataGrid = useSearchQuery(useGetEmailPulseOrdersDataQuery, {
    filteredSearchParams,
    getSearchResults: response =>
      transformEmailPulseDataGridResponse(response, 'id', 'emailTypeDisplay'),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            ordersSummary,
            emailsOpenedBreakdown,
            emailsBouncedBreakdown,
            ordersDataGrid,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />
          <EmailPulseHeader open={open} />

          {/* Summary Cards */}
          <OrdersSummaryCards />

          {/* Data Grid */}
          <Box height={{ xs: 400, sm: 600 }}>
            <OrdersDataGrid
              data-testid="Orders.OrdersDataGrid"
              queryName="ordersDataGrid"
              useExportMutation={useExportEmailPulseOrdersMutation}
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
      <ApiDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
